import React, { Component } from 'react'
import ReactDOM, { render, createPortal } from 'react-dom'
import BookNowForm from './bookNowForm';

const loadedStates = ['complete', 'loaded', 'interactive'];

class BookNowPopup extends Component {
  render() {
  	let not_found_section;
    let book_now_section = document.getElementById("book-now-form");
    if (book_now_section) {
      not_found_section = createPortal(<div className="not-found-book-form"><BookNowForm /></div>, book_now_section)
    }
    return  (
      <div>
        {not_found_section}
        <BookNowForm />
      </div>
    );
  }
}

export default BookNowPopup;
function executeReactComponent () {
ReactDOM.render(
  <BookNowPopup/>,
  document.getElementById('book_now_popup')
);
}

if (loadedStates.includes(document.readyState) && document.body) {
  executeReactComponent();
} else {
  window.addEventListener('DOMContentLoaded', executeReactComponent, false);
}
